import React, { useContext } from "react";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { saveTicketChanges, TicketDatabase } from "../../Utils/TicketDatabase";
import { useLiveQuery } from "dexie-react-hooks";
import FuelCalculator from "../../Utils/FuelCalculator";
import Box from "@mui/material/Box";
import NumberEditor from "../inputs/numberEditor";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { findById } from "../../Utils/ContextLookups";
import { GlobalContext } from "../../Utils/Contexts";

export default function MinimumsAveraging(props: TicketProps): JSX.Element {
    const context = useContext(GlobalContext);

    const aircraftList = useLiveQuery(async () => TicketDatabase.aircraft.toArray());

    if (!aircraftList) return <></>;

    const aircraft = findById(aircraftList, props.ticket.aircraft_id);

    const ticketFuel = FuelCalculator.Calculate(props.ticket, aircraft);

    const toAllocateText = ticketFuel.fuelToAllocate.lt(0) ? "OVER ALLOCATED" : "REMAINING";
    const toAllocateColor = !ticketFuel.fuelToAllocate.eq(0) ? "warning.main" : "black";

    const col1width = 10.0;
    const col2width = 2.0;

    return (
        <Grid key={`averaged`} container flexDirection={"row"} spacing={1} alignItems={"center"} sx={{ mt: 0.6, mb: 1 }}>
            <Grid xs={col1width} key={`averaged2`} item>
                <Box flexDirection={"row"}>
                    <FormControlLabel
                        labelPlacement={"start"}
                        control={
                            <Checkbox
                                disabled={props.isReadOnly}
                                checked={(props.ticket.is_averaged ?? 0) !== 0}
                                onChange={(e) => {
                                    handleAveragedCheckboxChange("is_averaged", e.target.checked);
                                }}></Checkbox>
                        }
                        label="MINIMUMS AVERAGED?"
                    />
                </Box>
            </Grid>
            <Grid xs={col2width} key={`averaged3`} item>
                <NumberEditor
                    sourceId={props.ticket.id}
                    sourceProperty="averaged_days"
                    labelText="DAYS"
                    isRequired={false}
                    initialValue={props.ticket.averaged_days}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/minimums"}
                    precision={0}
                />
            </Grid>
        </Grid>
    );

    function handleAveragedCheckboxChange(fieldName: string, value: boolean): void {
        // there is no onBlur for a checkbox so just update the ticket directly on change
        const intValue = value ? 1 : 0;
        saveTicketChanges(props.ticket.id, { is_averaged: intValue }).catch(() => props.showForceReloadDialogue());
    }
}
